import { getAutoringPoolNumber, setDisplayNumbers, formatPhoneNumber, setType2Attribute } from './phoneNumbers.js';
import { isNumeric } from './utils.js';

export const runAutoringpool = (ringpoolNumbers = [], callback) => {
    if(ringpoolNumbers.length === 0) {
        console.log('No ringpool numbers found');
        return;
    }

    const ringPoolIDs = [];
    ringpoolNumbers.forEach(node => {
      const rpid = node.dataset.ringpoolAltId;
      const tfn = node.dataset.ringpoolAltFallback;
      const altFormat = node.dataset.altFormat;
      const ga = node.dataset.ga;

      if(typeof(rpid) !== 'undefined' && typeof(tfn) !== 'undefined') {
        node.setAttribute('placeholder', formatPhoneNumber(tfn, altFormat));
        node.setAttribute('ringpoolid', rpid);
        if (typeof(ga) !== 'undefined' && ga === 'referral-call') {
            node.setAttribute('href', `tel:${formatPhoneNumber(tfn, altFormat)}`);
        }
        node.innerHTML = node.innerHTML.replace(/\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/, formatPhoneNumber(tfn, altFormat));
        if (isNumeric(rpid) && !ringPoolIDs.includes(rpid)) {
          ringPoolIDs.push(rpid);
        }
      }
    });

    if (ringPoolIDs.length > 0) {
        const phoneButton = document.querySelector('[data-ringpool-phone]');
        getAutoringPoolNumber(ringPoolIDs, 1, (numbers) => {
            numbers.forEach((node) => {
                setDisplayNumbers(node.ring_pool_id, node.number);
            });
            phoneButton?.dispatchEvent(new CustomEvent('ringPoolType1Loaded', {}));
            console.log('Ringpool typeid 1 numbers loaded...');
        });

        // 2nd Call to get unique phone numbers for child pages tracking (typeid = 2)
        getAutoringPoolNumber(ringPoolIDs, 2, (numbers) => {
            numbers.forEach((node) => {
                setType2Attribute(node.ring_pool_id, node.number);
            });
            phoneButton?.dispatchEvent(new CustomEvent('ringPoolType2Loaded', {}));
            console.log('Ringpool typeid 2 numbers loaded...');
            // Finally, run the callback function
            if (callback !== undefined) {
                callback();
            }
        });
    }
};
